export class Expandablelist {
	constructor(component_id) {
		this.id = component_id;
	}

	init() {
		const expanded_class = 'expandablelist__cell--expanded';
		const id = this.id;

		document.querySelectorAll('.js-' + id + '_arrow').forEach(arrow => {
			arrow.addEventListener('click', () => {
				const cell = arrow.closest('.js-' + id + '_cell');
				if (!cell) return;

				const dropdown = cell.querySelector('.js-' + id + '_dropdown');

				if (cell.classList.contains(expanded_class)) {
					cell.classList.remove(expanded_class);
					return;
				}

				this._close_all(expanded_class, id, cell);

				if (dropdown && dropdown.children.length > 0) {
					cell.classList.add(expanded_class);
				}
			});
		});

		const show_more = document.querySelector('.js-' + id + '_show_more');
		const show_less = document.querySelector('.js-' + id + '_show_less');
		if (show_more && show_less) {
			const collapsed_class = 'expandablelist__grid--collapsed';

			show_more.addEventListener('click', () => {
				const grid = show_more.previousElementSibling;
				if (grid) {
					grid.classList.remove(collapsed_class);
					show_more.style.display = 'none';
					show_less.style.display = 'flex';
				}
			});

			show_less.addEventListener('click', () => {
				const grid = show_more.previousElementSibling;
				if (grid) {
					grid.classList.add(collapsed_class);
					show_less.style.display = 'none';
					show_more.style.display = 'flex';
				}
			});
		}

		this._clickListener = (e) => {
			const cell = e.target.closest('.js-' + id + '_cell');
			if (cell) return;

			this._close_all(expanded_class, id);
		};
		document.removeEventListener('click', this._clickListener);
		document.addEventListener('click', this._clickListener);
	}

	_close_all(expanded_class, id, except_cell = null) {
		document.querySelectorAll('.js-' + id + '_cell.' + expanded_class).forEach(cell => {
			if (cell !== except_cell) {
				cell.classList.remove(expanded_class);
			}
		});
	}
}
